import React from 'react'
import { CarouselItem } from './carousel-item'
import { LeftContent } from './left-content'
import { RightContent } from './right-content'
import { HaulerAppStoreButtons } from '../../../hauler-app-store-buttons'

export const HaulerHero = () => {
  return (
    <CarouselItem>
      <LeftContent
        description="The first simple and affordable mobile data entry system for any milk hauling organization. Operating on both Android or iPhone/iPad systems"
        title="Mobile App Ticket Data Entry"
      >
        <HaulerAppStoreButtons className="animate__animated animate__fadeInUp" />
      </LeftContent>

      <RightContent url="hauler/hauler-mobile.png" alt="hauler mobile app" />
    </CarouselItem>
  )
}
